import { Region } from "shared/services/appConfig/types";
import type { CurrentUser, Organisation } from "shared/stores/user/types";

export function getInitialCurrentUserState(): CurrentUser {
  return {
    access_level: ["limited"],
    active: false,
    admin: false,
    alerts_read_at: null,
    auto_refresh_streams: false,
    created_at: null,
    currency_code: "",
    email: "",
    enforce_two_factor: false,
    first_name: "",
    front_page_summary_read_at: null,
    hidden: false,
    id: 0,
    international_phone_number: null,
    language: "",
    last_name: "",
    launchpad_beta: false,
    locale: "",
    media_requests_seen_at: null,
    news_summary_read_at: null,
    notifications_enabled: false,
    organisation: {
      dashboard_date_range: "",
      id: 0,
      logo_url: "",
      name: "",
      region: Region.AU,
    },
    organisation_brand: {
      logo_url: "",
      name: "",
      theme_color: "",
    },
    organisation_team_id: null,
    organisation_teams: [],
    other_organisations: [],
    outreach_countries: [],
    outreach_country: [],
    outreach_permissions: [],
    outreach_role: "",
    permissions: [],
    phone_country_code: null,
    phone_number: null,
    preferences: {},
    primary_organisation_team_id: 0,
    push_to_team_active: false,
    role: "",
    secondary_team_ids: [],
    show_intercom: false,
    social_permissions: [],
    social_role: "",
    time_zone: "",
    transcripts_read_at: null,
    two_factor_auth_carrier: null,
    two_factor_auth_enabled: false,
    user_hash: "",
    welcome_sent_at: null,
  };
}

export function getInitialOrganisationState(): Organisation {
  return {
    account_manager: {
      email: "",
      id: 0,
      name: "",
    },
    active: false,
    aircall_option: "",
    allowed_phone_country_codes: [],
    contract_services: [],
    custom_help_center_contact: "",
    custom_help_message: "",
    custom_support_contact: null,
    daily_report_range_duration: 0,
    daily_report_range_offset: 0,
    dashboard_date_range: "",
    default_role_id: 0,
    features: [],
    global_customer_id: null,
    help_center_contact_option: "",
    help_message_option: "",
    id: 0,
    logo_url: "",
    max_date_range: 0,
    name: "",
    organisation_brands: [],
    organisation_teams: [],
    pr_agency: false,
    region: Region.AU,
    secondary_account_managers: [],
    service_level: "",
    social_help_center_contact_option: "",
    social_support_contact_option: "",
    stock_symbol: null,
    support_contact_option: null,
    theme_color: "",
  };
}
